import { render, staticRenderFns } from "./ReceptionReport.vue?vue&type=template&id=a5e6f0fc"
import script from "./ReceptionReport.vue?vue&type=script&lang=js"
export * from "./ReceptionReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports